import { toJS } from 'mobx';

import type { TWellListState } from 'src/entities/well-list-panel-state';

export function serializeWellListPanelState(wellListPanelState: TWellListState): TWellListState {
  return {
    filterBy: wellListPanelState.filterBy,
    groupBy: wellListPanelState.groupBy,
    searchValue: wellListPanelState.searchValue,
    selectedWellId: wellListPanelState.selectedWellId,
    activeKeys: toJS(wellListPanelState.activeKeys),
    groupId: wellListPanelState.groupId,
    isPinned: wellListPanelState.isPinned,
    sorting: wellListPanelState.sorting,
  };
}
